import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Waves, Droplets, TestTube, Settings, Paintbrush, Workflow, Shield, Package, Layers, Activity, Flame, Wrench, ChevronRightIcon } from 'lucide-react';
import { categories } from '../data/categories';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
const categoryIcons: Record<string, any> = {
  pools: Waves,
  jacuzzi: Droplets,
  chemicals: TestTube,
  equipment: Settings,
  finishing: Paintbrush,
  pipes: Workflow,
  covers: Shield,
  accessories: Package,
  embedded: Layers,
  aquafitness: Activity,
  sauna: Flame,
  'spare-parts': Wrench
};
export function CatalogPage() {
  return <main className="min-h-screen bg-[#0a0a0a]" data-id="element-492">
      <div className="bg-[#0a0a0a] border-b border-[#1a1a1a]" data-id="element-493">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-494">
          <nav className="flex items-center gap-2 text-sm" data-id="element-495">
            <Link to="/" className="text-gray-500 hover:text-gray-300" data-id="element-496">
              Головна
            </Link>
            <span className="text-gray-700" data-id="element-497">/</span>
            <span className="text-white font-medium" data-id="element-498">Каталог</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12" data-id="element-499">
        <div className="mb-8 lg:mb-12" data-id="element-500">
          <h1 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-501">
            Каталог товарів
          </h1>
          <p className="text-lg text-gray-400 max-w-2xl" data-id="element-502">
            Все необхідне для басейну, сауни та відпочинку на воді. Оберіть
            категорію для перегляду товарів.
          </p>
        </div>

        <motion.div initial="hidden" animate="visible" variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-503">
          {categories.map((category, index) => {
          const Icon = categoryIcons[category.id] || Package;
          return <motion.div key={category.id} variants={itemVariants} data-id="element-504">
                <Link to={`/category/${category.slug}`} className="group relative block h-full" data-id="element-505">
                  <div className="relative bg-[#1a1a1a]/40 backdrop-blur-md border border-[#2a2a2a]/50 rounded-2xl p-7 overflow-hidden transition-all duration-300 hover:bg-[#1e1e1e]/60 hover:border-blue-500/30 h-full min-h-[120px]" data-id="element-506">
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/[0.03] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-507" />

                    <div className="relative flex items-center gap-6 h-full" data-id="element-508">
                      <div className="w-16 h-16 rounded-xl bg-[#1a1a1a] border border-[#2a2a2a] flex items-center justify-center group-hover:bg-blue-500/10 group-hover:border-blue-500/30 transition-all duration-300 flex-shrink-0" data-id="element-509">
                        <Icon className="w-8 h-8 text-gray-500 group-hover:text-blue-500 transition-colors duration-300" data-id="element-510" />
                      </div>

                      <div className="flex-1 min-w-0" data-id="element-511">
                        <h3 className="text-xl font-semibold text-white group-hover:text-blue-400 transition-colors duration-300 mb-1.5" data-id="element-512">
                          {category.name}
                        </h3>
                        <p className="text-sm text-gray-500" data-id="element-513">
                          {category.productCount} товарів
                        </p>
                      </div>

                      <ChevronRightIcon className="w-6 h-6 text-gray-600 group-hover:text-blue-500 group-hover:translate-x-1 transition-all duration-300 flex-shrink-0" data-id="element-514" />
                    </div>
                  </div>
                </Link>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </main>;
}